import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { AutoSellConfirmationBody, AutoSellConfirmationFooter } from ".";
import { Modal } from "@lib/modal";

export const BetDetailsAutoSellConfirmation = observer(
	function BetDetailsAutoSellConfirmation() {
		const { t } = useTranslation();

		const store = useContext(BetDetailsModalStoreContext);

		if (!WEBPACK_IS_AUTOCASHOUT_ENABLED || !store.isAutoSellOpen) {
			return null;
		}

		return (
			<Modal>
				<div className="popup">
					<div className="popup__card">
						<div className="popup__header">
							{t("mybets:CASHOUT.AUTO_CASHOUT_HEADER_TITLE")}
						</div>
						<div
							id="myBetsAutosellConfirmation"
							className="popup__body"
						>
							<AutoSellConfirmationBody />
						</div>
						<div className="popup__footer">
							<AutoSellConfirmationFooter />
						</div>
					</div>
				</div>
			</Modal>
		);
	}
);
